import { bookingMainMixin } from "@/mixins/bookingMainMixin";

export const prBookingMainMixin = {
    mixins: [bookingMainMixin],
    data() {
        return {
            apiBasePath: '', // To be defined by component
        };
    },
    methods: {
        async getDetailBooking(val) {
            let start = `${this.moment(val).format("YYYY-MM-DD")}T00:00:00+07:00`;
            let End = `${this.moment(val).format("YYYY-MM-DD")}T23:59:59+07:00`;
            try {
                const res = await this.$http.get(
                    `${this.apiBasePath}?timestart=${encodeURIComponent(
                        start
                    )}&timeend=${encodeURIComponent(End)}&status=approve,success`
                );
                if (res.status === 200) {
                    let listData = res.data.filter((data) => data['status'] != 'cancel')
                    if (listData.length > 0) {
                        listData.sort((a, b) => {
                            return a.id - b.id;
                        })
                        this.listOfBooking = listData
                    } else {
                        this.isEmptyBooking = true;
                    }
                    this.isLoadedBookingInfo = true;
                }
            } catch (error) {
                this.openNotification({
                    title: `Error ${error.response ? error.response.status : 'Unknown'}`,
                    msg: `Problem issue connect api : ${this.apiBasePath}?timestart=${encodeURIComponent(
                        start
                    )}&created_at__lte=${encodeURIComponent(End)}`,
                    backgroundColor: "#ff1919",
                    color: "#ffffff",
                });
                this.isLoadedBookingInfo = true;
            }
        },
        async getBooking(startMonth, endMonth) {
            try {
                this.isCalendarLoaded = false
                const res = await this.$http.get(
                    `${this.apiBasePath}?timestart=${encodeURIComponent(
                        startMonth
                    )}&timeend=${encodeURIComponent(endMonth)}&status=wait,approve,success`
                );
                if (res.status === 200) {
                    this.logBooking = [];
                    this.logBooking = res.data.map((item) => ({
                        ...item,
                        type: "info",
                        content: item.name_of_event,
                        colorcontent:
                            item.status === "approve"
                                ? "#0d9f3f"
                                : item.status === "wait"
                                    ? "#ffe562"
                                    : "#ffb2b2",
                    }));
                    this.isCalendarLoaded = true
                } else {
                    const error = new Error('API Error');
                    error.res = res;
                    throw error;
                }
            } catch (error) {
                this.isCalendarLoaded = true
                this.openNotification({
                    title: `Error ${error.response ? error.response.status : 'Unknown'}`,
                    msg: `Problem issue connect api : /booking/calendar/?timestart=${startMonth}&timeend=${endMonth}`, // Kept original message format or should genericize?
                    backgroundColor: "#ff1919",
                    color: "#ffffff",
                });
            }
        },
    }
};
